import { TourAnchor } from "training/anchors";
import { ITourFollowUp } from "training/types";

/**
 * CLE-3015 — pieces Modules 3–6 share.
 *
 * Since the Estimate Details redesign (CLE-2961, after the curriculum was checked) the page's actions —
 * Mark paid, Download ABN, Duplicate, Cancel — sit in a "..." menu at the top right, not in a row of
 * buttons; Redo, Collect Payment and Download GFE are header buttons on a Sent estimate (CLE-3018). Every
 * step on a menu item carries this `opener`, so the engine first has the trainee open the menu
 * (`<id>-open`).
 *
 * Not curriculum text: the curriculum predates the menu.
 */
export const ESTIMATE_ACTIONS_MENU: ITourFollowUp = {
  anchor: TourAnchor.EstimateActions,
  label: "Estimate actions",
  text: 'Open the "..." menu at the top right of the estimate.',
};

/**
 * The first time the menu is opened (3.8), the opener says what is in it: John's definitions (review 1),
 * then the instruction the click step needs.
 */
export const ESTIMATE_ACTIONS_MENU_FIRST: ITourFollowUp = {
  ...ESTIMATE_ACTIONS_MENU,
  text: [
    'This drop down (the "..." at the top right) will provide additional actions for the user.',
    "Cancel estimate will mark the estimate as cancelled and prevent the patient from paying.",
    "Mark paid via Cash will be used should the patient present on day of service and pay using cash.",
    "Mark paid via Check will be used should the patient pay using a Check.",
    "Duplicate Estimate will allow you to clone the estimate, which has a number of usages.",
    "Click it to open the menu.",
  ].join("\n"),
};
